var lib_core = require("lib-core");

var AssetAdderStateMachineMixin = function (self, end_state) {
    end_state = end_state || "idle";


    self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.NODE_MOUSE_DOWN && cEvent.data('type') != "3dmodel";
        },

        function(cEvent){
            self.assetId = cEvent.data('content_server_id');
            self.assetType = (cEvent.data('type') || self.assetType);

            //this may/should become asynchronous
            self.resource = self.root.dataLoader.dataManager.getResource(self.assetType, self.assetId, true);

            self.assetVersion = self.resource.getLastVersion().version;
            self.createInstance();
        }
    );

};

module.exports = AssetAdderStateMachineMixin;
